module.exports = __webpack_public_path__ + "img/headphones-01.8840aa99.svg";